import React from 'react';
import PropTypes from 'prop-types';
import { RightOutlined } from '@ant-design/icons';

// DS
import {
  VertBreadcrumb,
  VertIcon,
  VertRate,
  VertTag,
  VertTypography,
  VertWishlist,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Product/ProductHeaderStyles.less';

import CategoryBreadcrumb from '../CategoryBreadcrumb';

// UTILS
import { pointsMask, ratePointsMask } from 'Utils/commons/mask';


// PRODUCT HEADER COMPONENT
const ProductHeader = ({
  sku, seller, title, rate, favorited, toogleWishList, hasAboutProduct, refAboutProduct, discountRate, categoryHierarchy
}) => {
  const breadcrumbMock = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Detalhes do produto',
      path: `/product/${sku}`,
    },
  ];

  const scrollToAboutProduct = (elementRef) => {
    window.scrollTo({
      top: refAboutProduct.current.offsetTop,
      behavior: "smooth",
    });
  };

  /* Renders */
  return (
    <div data-testid="product-page-header" className="pdp-header">
      <VertBreadcrumb hasBackButton={true}
        separator={<VertIcon component={RightOutlined} />}
        items={breadcrumbMock}
      />

      <VertTypography.Title>
        {title}
      </VertTypography.Title>

      <div className="info-wrapper">
        <VertTypography.Paragraph>
          {seller}
        </VertTypography.Paragraph>

        {rate?.average && (
          <>
            <VertRate
              allowHalf
              disabled
              size="small"
              template="marketplace"
              value={rate.average}
            />

            <div className="rate-description">
              <VertTypography.Paragraph>
                {ratePointsMask(rate.average)}
              </VertTypography.Paragraph>
            </div>
          </>
        )}

        {hasAboutProduct && (
          <>
            <VertTypography.Paragraph>
              <span className="separator">
                |
              </span>
            </VertTypography.Paragraph>

            <a onClick={scrollToAboutProduct} className="description-link">
              <VertTypography.Paragraph>
                Descrição completa
              </VertTypography.Paragraph>
            </a>
          </>
        )}

           <VertTypography.Paragraph>
              <span className="separator">
                |
              </span>
            </VertTypography.Paragraph>

          <div className='container-favorite-product'>
            <span className="favorite-product">
              <VertWishlist
                label="Favoritar"
                template="marketplace"
                onClick={toogleWishList}
                favorited={favorited}
              />
            </span>
          
        {discountRate > 0 && (
          <>
            <VertTypography.Paragraph>
              <span className="separator">
                |
              </span>
            </VertTypography.Paragraph>
            <VertTag shape="round" status="error" className="borderless margin-left-extra-small margin-right-none">{discountRate}%</VertTag>
          </>
        )}
          </div>

      </div>

      <CategoryBreadcrumb 
        categoryHierarchy={categoryHierarchy}
      />
    </div>
  );
};

ProductHeader.propTypes = {
  sku: PropTypes.string,
  seller: PropTypes.string,
  title: PropTypes.string,
  rate: PropTypes.number,
  favorited: PropTypes.bool,
  hasAboutProduct: PropTypes.bool,
  toogleWishList: PropTypes.func,
  discountRate: PropTypes.number,
};

export default ProductHeader;
